import React from 'react';
import styles from './Textarea.module.css';

const DescriptionTextarea = React.forwardRef(({ placeholder = "Nhập mô tả...", ...props }, ref) => {
    return (
        <textarea
            ref={ref}
            placeholder={placeholder}
            className={styles.textarea}
            rows="5"
            {...props}
        />
    );
});

export default DescriptionTextarea;